import { render, staticRenderFns } from "./GraphicPerStudent.vue?vue&type=template&id=0bdfd19d&"
import script from "./GraphicPerStudent.js?vue&type=script&lang=js&"
export * from "./GraphicPerStudent.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports